"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const pricingOptions = [{
    label: "Initial Consult",
    duration: "30 min",
    price: "$99"
  }, {
    label: "Follow-Up",
    duration: "30 min",
    price: "$95"
  }, {
    label: "Follow-Up",
    duration: "45 min",
    price: "$135"
  }, {
    label: "Follow-Up",
    duration: "1 hour",
    price: "$175"
  }];
  return <section id="hero" className="relative w-full min-h-screen flex flex-col items-center justify-center bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537983/img/modern_sunlit_physiotherapy_studio.png)]">
      <div className="absolute inset-0 bg-gradient-to-b from-white/80 to-transparent pointer-events-none" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 py-12 sm:py-16 text-center">
        <h1 ref={headlineRef} className={`font-display text-[48px] sm:text-[56px] lg:text-[64px] leading-[1.2] font-bold tracking-tight text-foreground mb-4 transition-all duration-[var(--duration-medium)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Treating the cause, not just the pain
        </h1>

        <div ref={gridRef} className={`grid grid-cols-1 lg:grid-cols-[auto_auto] justify-center items-center gap-8 mb-12 transition-all duration-[var(--duration-medium)] delay-200 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {}
          <div data-index={0} className="flex flex-col items-center justify-center p-6 bg-white/90 backdrop-blur-sm rounded-md shadow-soft border border-border hover:bg-primary-light/30 transition-colors duration-[var(--duration-fast)]">
            <p className="text-sm font-semibold text-foreground mb-1">
              {pricingOptions[0].label}
            </p>
            <p className="text-xs text-muted-foreground mb-2">{pricingOptions[0].duration}</p>
            <p className="text-2xl font-bold text-primary">{pricingOptions[0].price}</p>
          </div>

          {}
          <div className="flex flex-row justify-center gap-4">
            {pricingOptions.slice(1).map((option, i) => <div key={i + 1} data-index={i + 1} className="flex flex-col items-center justify-center p-6 bg-white/90 backdrop-blur-sm rounded-md shadow-soft border border-border hover:bg-primary-light/30 transition-colors duration-[var(--duration-fast)]">
                <p className="text-sm font-semibold text-foreground mb-1">
                  {option.label}
                </p>
                <p className="text-xs text-muted-foreground mb-2">{option.duration}</p>
                <p className="text-2xl font-bold text-primary">{option.price}</p>
              </div>)}
          </div>
        </div>

        <div ref={ctaRef} className={`transition-all duration-[var(--duration-medium)] delay-300 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Button asChild size="lg" className="shadow-medium text-white">
            <Link to="/BookAppointmentPage">Book Your Appointment</Link>
          </Button>
        </div>
      </div>
    </section>;
}